var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sign-out_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M4.934 1a1.75 1.75 0 0 0-1.75 1.75v10.5c0 .966.783 1.75 1.75 1.75H7.44a5.5 5.5 0 0 1-.658-1h-1.85a.75.75 0 0 1-.75-.75V2.75a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 .75.75v3.272q.517.048 1 .185V2.75A1.75 1.75 0 0 0 11.434 1zm2.25 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.353-2.146a.5.5 0 0 1-.707-.708L12.476 12H9.685a.5.5 0 0 1 0-1h2.793L11.33 9.854a.5.5 0 0 1 .707-.708l2 2a.5.5 0 0 1 .147.351v.006a.5.5 0 0 1-.145.348l-.002.003z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sign-out_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.184 0h16v16h-16z"
  })))));
};
export default SvgSignOut;